import { z } from 'zod'

export const billingTopupWriteResponseSchema = z.object({}).passthrough()
export type BillingTopupWriteResponse = z.infer<typeof billingTopupWriteResponseSchema>
